<template>
	<div class="content-search" >
		<b-container fluid="xl">
			<b-row
				v-if="!isMobile"
				style="display: flex;vertical-align: middle;flex-direction: row;box-sizing: border-box;display: flex;place-content: center;align-items: center;text-align: center;font-size: 26px;color: var(--projectPrimaryColor);margin-bottom: 30px;margin-top: -10px;"
			>
				<span v-if="categorySelected == 'marketPlace'"
					>{{$t('search.you are looking for Or do you want to sell products?')}}</span
				>
				<span v-if="categorySelected == 'realEstate'"
					>{{$t('search.you are looking for or want to sell Is there real estate?')}}</span
				>
				<span v-if="categorySelected == 'carsEngines'"
					>{{$t('search.you are looking for Or do you want to sell your car and engine?')}}</span
				>
				<span v-if="categorySelected == 'findMotercycle'">
					{{$t('search.you are looking for Or do you want to sell your motorbike?')}}</span
				>
				<span v-if="categorySelected == 'features'">
					{{$t('search.you are looking for Or want to sell products or not?')}}</span
				>
			</b-row>
			<div style="width:970px;height:250px;margin:20px auto;" v-if="!isMobile">
				
				<a
					:href="searchAdsUnderTitle.website"
					target="_blank"
					id="imageFooter"
					v-if="!searchAdsUnderTitle.advertisment_location.google_on"
					@click="CLICK_BANNERADS(searchAdsUnderTitle.id)"
					>
					<b-img
						:src="searchAdsUnderTitle.image"
						class="img-card"
						style="max-width:100%; height:auto;"
						:alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
					></b-img>
				</a>
				<Adsense
					v-else
					data-ad-test="false"
					in-style="display:inline-block;width:970px;height:250px"
					:data-ad-client="$root.googleClientId"
					:data-ad-slot="searchAdsUnderTitle.advertisment_location.google_ad_key"  
				>
				</Adsense>
			</div>
			<b-row>
				<b-col cols="12" md="3" class="d-flex tooltip-search">
					<div class="search-keyword">
						{{ searchTitle ? searchTitle : '' }}
					</div>
				</b-col>

				<b-col cols="12" md="9" class="tooltip-search" @click="handleSearchBlur">
					<b-row no-gutters>
						<b-col :cols="isMobile ? 6 : 3" order="2" order-md="1">
							<div class="select-sort-by">
								<b-dropdown
									no-flip
									v-model="search_params.orderBy"
									class="input-choose-condition float-right float-md-none"
								>
									<template v-slot:button-content>
										<span>
											{{
												orderByItem && orderByItem.value
													? orderByItem.value
													: $t('search.mostRelevant')
											}}
											<ChevronDownIcon />
										</span>
									</template>
									<b-dropdown-item
										@click="
											getItemOrderBy('MostRelevant', $t('search.mostRelevant'))
										"
									>
										{{ $t('search.mostRelevant') }}
									</b-dropdown-item>
									<b-dropdown-item
										@click="
											getItemOrderBy('Latest', $t('search.latestListing'))
										"
									>
										{{ $t('search.latestListing') }}
									</b-dropdown-item>
									<b-dropdown-item
										@click="getItemOrderBy('PriceHigh', $t('search.priceHigh'))"
									>
										{{ $t('search.priceHigh') }}
									</b-dropdown-item>
									<b-dropdown-item
										@click="getItemOrderBy('PriceLow', $t('search.priceLow'))"
									>
										{{ $t('search.priceLow') }}
									</b-dropdown-item>
								</b-dropdown>
							</div>
						</b-col>
						<b-col :cols="isMobile ? 6 : 3" order="1" order-md="2">
							<div class="group-btn float-none float-md-right">
								<b-button
									id="changeViewTypeGrid"
									@click="handleChangeViewType('grid')"
									class="btn-grid"
									v-bind:class="{ active: activeButton == 'grid' }"
								>
									<ListGridIcon />
								</b-button>
								<b-button
									id="changeViewTypeList"
									@click="handleChangeViewType('list')"
									class="btn-list"
									v-bind:class="{ active: activeButton == 'list' }"
								>
									<FormatListBulletedIcon />
								</b-button>
							</div>
						</b-col>
						<b-col
							v-if="!isMobile"
							cols="6"
							class="pd-lr-7"
							align-self="center"
							order="3"
							order-md="3"
						>
							<div class="wrap-btn text-right">
								<UserMenuDropdown v-if="$root.isAuthenticated" :userName="userName" />
								<template v-else>
									<b-button
										id="login"
										@click="openThairathLogin"
										class="btn-login btn-item"
									>
										<IconLogin />
										{{ $t('login') }}
									</b-button>
									<b-button
										class="register-member btn-item"
										id="signUp"
										@click="
											$root.signIn('search');
										"
									>
										<IconUserPlus />
										{{ $t('signup') }}
									</b-button>
								</template>
							</div>
						</b-col>
					</b-row>

					<div class="line-bottom"></div>
				</b-col>
				<b-col cols="3" class="pr-10 pt-35 d-none d-lg-block">
					<div class="wrap-tooltip-left">
						<div class="wrap-input-search">
							<b-form-input
								:class="{ 'active-suggest': isSuggest && suggestList.length }"
								autocomplete="off"
								class="input-search"
								ref="searchInput"
								:placeholder="$t('search.search')"
								v-model="search_params.search"
								
								@focus="isSuggest = true"
							></b-form-input>
							<MagnifyIcon class="icon-search" />
							<ul
								ref="suggest"
								class="suggest-search"
								v-if="suggestList.length && isSuggest"
							>
								<li
									@click="searchSuggest(item)"
									v-for="(item, index) in suggestList"
									:key="index"
								>
									{{ item }}
								</li>
							</ul>
						</div>
						<div class="wrap-chose">
							<div class="title-tooltip-left">{{ $t('packages.type') }}</div>
							<b-dropdown
								no-flip
								class="input-choose-condition"
								:disabled="jobType.isCheck ? true : false"
							>
								<template v-slot:button-content>
									<span>
										{{ packageItem ? packageItem.text : $t('packages.type') }}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item @click="handlePackageType(null)">
									{{ $t('all') }}
								</b-dropdown-item>
								<b-dropdown-item
									@click="handlePackageType(item)"
									v-for="(item, index) in packageType"
									:key="index"
									value="item.value"
								>
									{{ item.text }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="category-treeview">
							<div class="title-tooltip-left">{{ $t('category') }}</div>
							<div class="control_wrapper">
								<b-card
									v-for="(catagory, index) in categoriesOptions"
									:key="index"
									no-body
									class="mb-1"
								>

									<div class="d-flex align-items-center" v-if="catagory.id==2" @click="redirectIf(catagory.redirect_to)">
										<b-form-checkbox
											:class="'checkbox_parent_' + index + catagory.id"
											v-model="allSelected['catagory_' + catagory.id]"
										></b-form-checkbox>
										<b-button
											v-b-toggle="'accordion-' + index"
											variant="primary"
										>
											<span>{{ $t(catagory.name) }}</span>
											<span class="when-opened">
												<ChevronUpIcon />
											</span>
											<span class="when-closed">
												<ChevronDownIcon />
											</span>
										</b-button>
									</div>
									<div class="d-flex align-items-center" v-else>
										<b-form-checkbox
											:class="'checkbox_parent_' + index + catagory.id"
											v-model="allSelected['catagory_' + catagory.id]"
										></b-form-checkbox>
										<b-button
											v-b-toggle="'accordion-' + index"
											variant="primary"
										>
											<span>{{ $t(catagory.name) }}</span>
											<span class="when-opened">
												<ChevronUpIcon />
											</span>
											<span class="when-closed">
												<ChevronDownIcon />
											</span>
										</b-button>
									</div>

									<b-collapse :id="'accordion-' + index">
										<div class="ml-4">
											<div
												v-for="(item,
												key) in catagory.listing_category_children"
												:key="key"
												class="d-flex align-items-center"
											>
												<b-form-checkbox
													:value="item.id"
													v-model="catagoryCheck['catagory_' + catagory.id]"
												></b-form-checkbox>
												<b-button variant="primary">
													<span>{{ $t(item.name) }}</span>
												</b-button>
											</div>
										</div>
									</b-collapse>
								</b-card>
							</div>
						</div>
						<div>
							<template>
								<div class="wrap-input" v-if="attributes.bedRoom">
								
									<div class="title-tooltip-left">
										{{ $t('addListing.details.bedroom') }}
									</div>
									<b-form-input
										class="price-range-input"
										:placeholder="$t('addListing.details.numBedroom')"
										v-model="listing_attributes.bedroom.value"
									></b-form-input>
								</div>
								<div class="wrap-input" v-if="attributes.bathRoom">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.bathroom') }}
									</div>
									<b-form-input
										class="price-range-input"
										:placeholder="$t('addListing.details.numBathroom')"
										v-model="listing_attributes.bathroom.value"
									></b-form-input>
								</div>
								<div class="wrap-chose" v-if="attributes.saleRent">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.saleRent') }}
									</div>
									<b-dropdown
										no-flip
										class="input-choose-condition mt-10"
										:disabled="saleOrRent.isCheck ? true : false"
									>
										<template v-slot:button-content>
											<span>
												{{ saleOrRentItem ? saleOrRentItem.value : $t('hire') }}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											@click.native="getItemSaleOrRent(attr)"
											v-for="(attr, i) in saleOrRent.attr"
											:key="i"
											:value="attr.id"
										>
											{{ $t(attr.value) }}
										</b-dropdown-item>
									</b-dropdown>
								</div>
							</template>
							<template>
								<div class="wrap-input" v-if="attributes.brand">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.brand') }}
									</div>
									<b-form-input
										:placeholder="$t('addListing.details.carBrand')"
										v-model="listing_attributes.brand.value"
									></b-form-input>
								</div>
								<div class="wrap-input" v-if="attributes.year">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.year') }}
									</div>
									<b-form-input
										:placeholder="$t('addListing.details.year')"
										v-model="listing_attributes.year.value"
									></b-form-input>
								</div>
								<div class="wrap-chose" v-if="attributes.gearType">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.gearType') }}
									</div>
									<b-dropdown
										no-flip
										class="input-choose-condition"
										:disabled="gearType.isCheck ? true : false"
									>
										<template v-slot:button-content>
											<span>
												{{
													gearTypeItem
														? gearTypeItem.value
														: $t('addListing.details.typeOfGear')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											@click.native="getItemGearType(data)"
											v-for="(data, i) in gearType.attr"
											:key="i"
											:value="data.id"
										>
											{{ $t(data.value) }}
										</b-dropdown-item>
									</b-dropdown>
								</div>
								<div class="wrap-input" v-if="attributes.color">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.colorType') }}
									</div>
									<b-form-input
										:placeholder="$t('addListing.details.carColor')"
										v-model="listing_attributes.color.value"
									></b-form-input>
								</div>
								<div class="wrap-input" v-if="attributes.Mileage">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.milage') }}
									</div>
									<b-form-input
										:placeholder="$t('addListing.details.milage')"
										v-model="listing_attributes.mileage.value"
									></b-form-input>
								</div>
							</template>
							<template>
								<div class="wrap-chose" v-if="attributes.jobType">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.jobType') }}
									</div>
									<b-dropdown
										no-flip
										class="input-choose-condition"
										:disabled="jobType.isCheck ? true : false"
									>
										<template v-slot:button-content>
											<span>
												{{ jobTypeItem ? $t(jobTypeItem.value) : $t('all') }}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											@click.native="getItemJobType(data)"
											v-for="(data, i) in jobType.attr"
											:key="i"
											:value="data.id"
										>
											{{ $t(data.value) }}
										</b-dropdown-item>
									</b-dropdown>
								</div>
								<div class="wrap-input" v-if="attributes.salary">
									<div class="title-tooltip-left">
										{{ $t('addListing.details.salary') }}
									</div>
									<b-form-input
										:placeholder="$t('search.minimum')"
										type="number"
										v-model="search_params.minimum_salary"
									></b-form-input>
									<b-form-input
										:placeholder="$t('search.maximum')"
										class="mt-10"
										type="number"
										v-model="search_params.maximum_salary"
									></b-form-input>
								</div>
							</template>
							<template>
								<div v-if="attributes.price" class="wrap-price-range">
									<div class="title-tooltip-left">
										{{ $t('search.priceRange') }}
									</div>
									<b-form-input
										class="price-range-input"
										type="number"
										:placeholder="$t('search.minimum')"
										v-model="search_params.minimum_price"
									></b-form-input>
									<b-form-input
										class="price-range-input"
										type="number"
										:placeholder="$t('search.maximum')"
										v-model="search_params.maximum_price"
									></b-form-input>
								</div>
								<div class="wrap-chose-area">
									<div class="title-tooltip-left">
										{{ $t('search.area') }}
									</div>
									<b-dropdown no-flip class="input-choose">
										<template v-slot:button-content>
											<span>
												{{
													provinceName != null
														? $t(provinceName.name)
														: $t('search.allProvinces')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item @click="getItemProvince(null)">
											{{ $t('all') }}
										</b-dropdown-item>
										<b-dropdown-item
											@click.native="getItemProvince(province)"
											v-for="(province, i) in provinces"
											:key="i"
											:value="province.id"
										>
											{{ $t(province.name) }}
										</b-dropdown-item>
									</b-dropdown>
									<b-dropdown
										no-flip
										class="input-choose mt-10"
										:disabled="provinceName != null ? false : true"
									>
										<template v-slot:button-content>
											<span>
												{{
													districtName != null
														? $t(districtName.name)
														: $t('search.allDistricts')
												}}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item @click="getItemDistrict(null)">
											{{ $t('all') }}
										</b-dropdown-item>
										<b-dropdown-item
											@click.native="getItemDistrict(data)"
											v-for="(data, i) in arrListDistrict"
											:key="i"
											:value="data.id"
										>
											{{ $t(data.name) }}
										</b-dropdown-item>
									</b-dropdown>
								</div>
								<div class="wrap-chose-condition" v-if="attributes.condition">
									<div class="title-tooltip-left">
										{{ $t('search.condition') }}
									</div>
									<b-dropdown
										no-flip
										class="input-choose-condition"
										:disabled="condition.isCheck ? true : false"
									>
										<template v-slot:button-content>
											<span>
												{{ conditionItem ? conditionItem.value : $t('all') }}
												<ChevronDownIcon />
											</span>
										</template>
										<b-dropdown-item
											@click.native="getItemCondition(attr)"
											v-for="(attr, i) in condition.attr"
											:key="i"
											:value="attr"
										>
											{{ $t(attr.value) }}
										</b-dropdown-item>
									</b-dropdown>
								</div>
							</template>
						</div>
					</div>
					<div class="image-left">
						<a
						:href="searchLeftAds.website"
						target="_blank"
						id="imageFooter"
						v-if="!searchLeftAds.advertisment_location.google_on"
						@click="CLICK_BANNERADS(searchLeftAds.id)"
						>
							<b-img
								:src="searchLeftAds.image"
								class="img-card"
								style="max-width:100%; height:auto;"
								:alt="$t('altTag',{
                      affiliate:$root.affiliate
                    })"
							></b-img>
						</a>
						<Adsense
							data-ad-test="false"
							in-style="display:block"
							:data-ad-client="$root.googleClientId"
							:data-ad-slot="searchLeftAds.advertisment_location.google_ad_key"  
							data-ad-format="rectangle"
							data-full-width-responsive="true"
						>
						</Adsense>
					</div>
				</b-col>
				
				<b-col
					cols="12"
					lg="9"
					class="wrap-card-search-page wrap-loading  text-center"
					v-if="categorisDataSearch.data.length == 0 && !loading"
				>
					<div v-if="!loading&&categorisDataSearch.data.length == 0 " class="notify_noData">
						<p>{{ $t('searchScreen.warning') }}</p>
						<p>{{ $t('searchScreen.noData') }}</p>
					</div>
				</b-col>
				
				<b-col
					cols="12"
					lg="9"
					v-if="categorisDataSearch.data.length  && !loading"
				>
					<SearchGrid
						v-if="
							showListOrGrid == 'grid' &&
								!loading &&
								categorisDataSearch.data.length
						"
						:categorySelected="categorySelected"
					></SearchGrid>
					<SearchList
						v-else-if="
							showListOrGrid == 'list' &&
								!loading &&
								categorisDataSearch.data.length
						"
						:categorySelected="categorySelected"
					></SearchList>
					<b-col cols="3" class="d-none d-lg-flex"></b-col>
					<b-col 
						class="text-center paginate-position">
						<div class="overflow-auto wrap-pagination d-md-block">
							<b-pagination-nav
								v-model="search_params.page"
								class="paginate-item"
								:prev-text="$t('nextPg')"
								:next-text="$t('prevPg')"
								:link-gen="paginationNumber"
								:number-of-pages="
									categorisDataSearch &&
									categorisDataSearch.meta &&
									categorisDataSearch.meta.pageCount
										? categorisDataSearch.meta.pageCount
										: 1
								"
								:replace="true"
								:current-page="search_params.page"
								use-router
							></b-pagination-nav>
						</div>
					</b-col>
				</b-col>
				<b-col cols="12" lg="9" class="d-flex flex-wrap skeleton" v-if="!categorisDataSearch.data.length&&loading">
					
					<div class="m-2" v-for="something in [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]" :key="something" style="height: 250px;">
						
							<CardSkeleton/>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';

import SearchGrid from '@/components/searchGrid';
import SearchList from '@/components/searchList';
import UserMenuDropdown from '@/components/ui/UserMenuDropdown';
import CardSkeleton from '@/components/ui/cardSkeleton';

// Icons
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import ListGridIcon from '@/components/icons/IconListGrid/index';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import IconUserPlus from '@/components/icons/IconUserPlus/index';
import IconLogin from '@/components/icons/IconLogin/index';

export default {
	components: {
		SearchGrid,
		SearchList,
		UserMenuDropdown,
		FormatListBulletedIcon,
		ListGridIcon,
		MagnifyIcon,
		ChevronUpIcon,
		ChevronDownIcon,
		IconUserPlus,
		IconLogin,
		CardSkeleton
	},
	data() {
		return {
			searchLeftAds: {
				website: "#",
				image: "",
				advertisment_location: {
				google_on: false
				}
			},
			searchAdsUnderTitle: {
				website: "#",
				image: "",
				advertisment_location: {
				google_on: false
				}
			},
			allAttr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
			showListOrGrid: 'grid',
			selectedSortBy: null,
			selectedChoseProvinces: null,
			selectedChoseDistrict: null,
			selectedChoseCondition: null,
			activeButton: 'grid',
			showFieldsSearch: '',
			attributes: {
				condition: false,
				saleRent: false,
				bedRoom: false,
				bathRoom: false,
				area: true,
				brand: false,
				Mileage: false,
				model: false,
				year: false,
				gearType: false,
				jobType: false,
				salary: false,
				price: true,
				color: false
			},
			selected: false,
			cata_1: [],
			allSelected: {
				catagory_1: false,
				catagory_2: false,
				catagory_3: false,
				catagory_4: false
			},
			catagoryCheck: {
				catagory_1: [],
				catagory_2: [],
				catagory_3: [],
				catagory_4: []
			},
			provinceName: null,
			orderByItem: {
				value: null
			},
			districtName: null,
			conditionItem: null,
			saleOrRentItem: null,
			gearTypeItem: null,
			jobTypeItem: null,
			catagoryAttr: [],
			page: 1,
			search_params: {
				take: 14,
				page:
					this.$route.query && this.$route.query.page
						? this.$route.query.page
						: 1,
				orderBy: 'MostRelevant',
				listing_category_ids: null,
				search: null,
				province_id: null,
				district_id: null,
				minimum_price: null,
				maximum_price: null,
				minimum_salary: null,
				maximum_salary: null,
				user_id:
					localStorage.getItem('user_profile') &&
					localStorage.getItem('user_profile')
						? JSON.parse(localStorage.getItem('user_profile')).id
						: null,
				listing_attributes: [],
				package_type: '',
				isAdmin:
					localStorage.getItem('user_profile') &&
					JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
						'Admin'
						? true
						: false
			},
			listing_attributes: {
				color: {
					attr_id: 13,
					value: null,
					attr_type: 'Textbox'
				},
				condition: {
					attr_id: 2,
					pre_values_id: null,
					attr_type: 'Number'
				},
				saleRent: {
					attr_id: 1,
					pre_values_id: null,
					attr_type: 'Number'
				},
				bedroom: {
					attr_id: 5,
					value: null,
					attr_type: 'Textbox'
				},
				bathroom: {
					attr_id: 6,
					value: null,
					attr_type: 'Textbox'
				},
				brand: {
					attr_id: 7,
					pre_values_id: null,
					value: null,
					attr_type: 'Textbox'
				},
				model: {
					attr_id: 8,
					value: null,
					attr_type: 'Textbox'
				},
				jobType: {
					attr_id: 17,
					pre_values_id: null,
					attr_type: 'Number'
				},
				year: {
					attr_id: 9,
					value: null,
					attr_type: 'Textbox'
				},
				mileage: {
					attr_id: 11,
					value: null,
					attr_type: 'Textbox'
				},
				gearType: {
					attr_id: 12,
					pre_values_id: null,
					attr_type: 'Number'
				}
			},
			listAttr: [],
			province_params: {
				take: -1
			},
			district_parms: {
				take: -1,
				province_id: null
			},
			list_attr_params: {
				take: -1,
				category_ids: null
			},
			condition: {
				isCheck: false,
				attr: []
			},
			saleOrRent: {
				isCheck: false,
				attr: []
			},
			jobType: {
				isCheck: false,
				attr: []
			},
			gearType: {
				isCheck: false,
				attr: []
			},
			loading: true,
			adsSearch: {
				link: '',
				url_image: ''
			},
			packageType: [
				{ text: this.$t('packages.promotions.title'), value: 'featured' },
				{ text: this.$t('packages.scrollTop.title'), value: 'move-up' },
				{ text: this.$t('packages.negotiable.title'), value: 'negotiable' },
				{ text: this.$t('packages.quickSale.title'), value: 'urgent' },
				{ text: this.$t('packages.highlights.title'), value: 'highlight' }
			],
			packageItem: null,
			categorySelected: 'features',
			isSuggest: false,
			valueBeforeSearch: 'undefined',
			userName:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).display_name
					? JSON.parse(localStorage.getItem('user_profile')).display_name
					: '',
			searchTitle: null,
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false
		};
	},
	mounted() {
		if (this.$route.name === 'SearchGrid') {
			document.body.className = '';
			if (this.$route.query && this.$route.query.page) {
				this.search_params.page = this.$route.query.page;
			}
		}
		if (this.$route.query) {
			const entries = Object.entries(this.$route.query);
			for (const [key, query] of entries) {
				// const patern = new RegExp('^(?!atr_).*$');
				if (key != 'categories') {
					this.search_params[key] = query;
					// } else if (key != 'categories') {
					// const attribute = key.split('_')[1];
					// this.listing_attributes[attribute].value = query;
					// this.listing_attributes[attribute].pre_values_id = parseInt(query);
				}
			}
			if (this.$route.query.package_type) {
				this.packageType.forEach(el => {
					if (el.value === this.search_params.package_type) {
						this.packageItem = el;
					}
				});
			}
		}
		// if(this.isMobile&&this.$route.query.categories){
		// 	this.fetchDataSearch();
		// }
	},
	created() {
		var textSearch = this.textSearch;
		if (this.$route.query.plan != 'mobile') {
			this.search_params.search = textSearch;

			this.GET_CATEGORY();

			this.fetchDataProvinces(this.province_params);
		

		if (this.dataSearch == null && this.$route.query.plan != 'mobile') {
			this.GET_CATEGORY();
			this.fetchDataProvinces(this.province_params);
			if (this.dataSearch == null) {
				this.GET_ID_ATTR({
					value: 1,
					title: this.$t('market')
				});
			}
		}

		if (this.categoryTitle) {
			setTimeout(() => {
				this.searchTitle = this.categoryTitle;
			}, 100);
			// this.$store.commit('CategoryController/SET_NULL_TITLE_SEARCH');
		}
		if (this.dataSearch) {
			if (this.dataSearch.title) {
				this.searchTitle = this.dataSearch.title;
			} else {
				this.searchTitle = '';
			}
		}
		}else{
			this.loading=false;
		}
		
		this.getAdsUnderTitle();
		this.getAdsLeft();
	},
	computed: {
		...mapGetters('UserController', [ 'isMobile']),
		...mapGetters('CategoryController', [
			'categoriesOptions',
			'provinces',
			'listingAttr',
			'categorisDataSearch',
			'textSearch',
			'dataSearch',
			'isCountMobile',
			'category',
			'listing_attr',
			'suggestList',
			'categoryTitle'
		]),
		...mapState('AddListingController', ['arrListDistrict'])
	},
	methods: {
		...mapActions('AddListingController', ['GET_LIST_DISTRICTS']),
		...mapActions('CategoryController', [
			'GET_CATEGORY',
			'GET_DATA_SEARCH_CATEGORY',
			'GET_DATA_PROVINCES',
			'GET_LISTING_ATTR',
			'GET_TEXT_SEARCH',
			'GET_ID_ATTR',
			'GET_LIST_SUGGEST'
		]),
		...mapActions("AdsController", [
			"GETADS_FOR_PUBLIC_WEBSITE",
			"CLICK_BANNERADS"
		]),
		redirectIf(redirect_to){
			// this.$swal({
			// 	title: this.$t('search.redirection.title'),
			// 	text: this.$t('search.redirection.subtitle'),
			// 	customClass: {
			// 		container: 'swal-del-item'
			// 	},
			// 	showCancelButton: true,
			// 	confirmButtonColor: 'var(--projectPrimaryColor)',
			// 	cancelButtonColor: '#DC3849',
			// 	confirmButtonText: this.$t('search.redirection.confirmTest'),
			// 	cancelButtonText: this.$t('search.redirection.cancelTest')
			// }).then(result => {
			// 	console.log("result",result)
			// 	 if(result.value){
			// 		window.open(redirect_to);
			// 	}
			// });
		},
		getFooterAds(locationId){
			console.log("locationId",locationId);
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: locationId
			}).then(({ data }) => {
			if (data) {
				this.adsFooter = data;
				this.$forceUpdate();
			}
			});
		},
		getAdsUnderTitle(){
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: 48
				}).then(({ data }) => {
				
				if (data) {
					this.searchAdsUnderTitle = data;
				}
			});
		},
		getAdsLeft(){
			this.GETADS_FOR_PUBLIC_WEBSITE({
				id: 13
				}).then(({ data }) => {
				
				if (data) {
					this.searchLeftAds = data;
				}
				});
		},
		
		handleChangeViewType(type) {
			this.activeButton = type;
			this.showListOrGrid = type;
		},
		paginationNumber(pageNum) {
			// window.scroll(0, 0);
			return {
				query: {
					...this.$route.query,
					page: pageNum
				}
			};
		},

		handleSearchBlur(ev) {
			
			
			if (
				ev.srcElement != (this.$refs.searchInput&&this.$refs.searchInput.$el) &&
				ev.srcElement != this.$refs.suggest
			) {
				this.isSuggest = false;
			}
		},

		manageQueries(type, val) {
			if (!val) {
				this.removeQuery(type);
			} else {
				const stringVal = val.toString();
				if (stringVal.length > 0) {
					// Push the query
					this.$router.push({
						query: {
							...this.$route.query,
							[type]: stringVal
						}
					});
				} else {
					this.removeQuery(type);
				}
			}
		},

		manageCategoriesQuery() {
			if (this.$route.query.categories) {
				// Get the query in an array
				const categoriesId = this.$route.query.categories.split(',');
				// Check if the category is in the query
				this.categoriesOptions.forEach((category, index) => {
					this.catagoryCheck[`catagory_${index + 1}`] = [];
					category.listing_category_children.forEach(subCategory => {
						categoriesId.forEach(id => {
							if (id == subCategory.id) {
								this.catagoryCheck[`catagory_${index + 1}`].push(
									subCategory.id
								);
							}
						});
					});
				});
			}
		},

		removeQuery(type) {
			let query = Object.assign({}, this.$route.query);
			delete query[type];
			this.$router.replace({ query });
		},

		handleSelected(val) {
			let array = [];
			if (this.catagoryCheck.catagory_1.length > 0) {
				for (let data of this.catagoryCheck.catagory_1) {
					array.push(data);
				}
			}
			if (this.catagoryCheck.catagory_2.length > 0) {
				for (let data of this.catagoryCheck.catagory_2) {
					array.push(data);
				}
			}
			if (this.catagoryCheck.catagory_3.length > 0) {
				for (let data of this.catagoryCheck.catagory_3) {
					array.push(data);
				}
			}
			if (this.catagoryCheck.catagory_4.length > 0) {
				for (let data of this.catagoryCheck.catagory_4) {
					array.push(data);
				}
			}
			this.search_params.listing_category_ids = array.toString();
		},
		handlePackageType(item) {
			this.packageItem = item;

			if (item != null) {
				this.search_params.package_type = item.value;
			} else {
				this.search_params.package_type = null;
			}
			this.manageQueries('package_type', this.search_params.package_type);
		},
		fetchDataSearch() {
			if(this.$route.name!="MobileAdvanceSearch"){
				let prms = { ...this.search_params };
				this.loading = true;
				this.GET_DATA_SEARCH_CATEGORY(prms).then(result => {
					this.loading = false;
					this.$forceUpdate();
				});
			}else{
				this.loading=false;
				this.$forceUpdate();
			}
		},
		fetchDataSearchNoAuto(prms) {
			this.loading = true;
			this.GET_DATA_SEARCH_CATEGORY(prms).then(result => {
				this.loading = false;
				this.$forceUpdate();
			});
		},
		fetchDataProvinces() {
			this.GET_DATA_PROVINCES(this.province_params);
		},
		fetchDataDistricts() {
			this.GET_LIST_DISTRICTS({
				take: -1,
				page: 1,
				province_id: this.district_parms.province_id
			});
		},
		fetchDataListingAttr() {
			this.GET_LISTING_ATTR(this.list_attr_params);
		},
		getItemProvince(item) {
			this.provinceName = item;

			if (item != null) {
				this.search_params.province_id = item.id;
			} else {
				this.search_params.province_id = null;
			}
		},
		getItemDistrict(item) {
			if (item != null) {
				this.search_params.district_id = item.id;
			} else {
				this.search_params.district_id = null;
			}

			this.districtName = item;
		},
		handleCheckListing(val) {
			if (this.search_params.listing_attributes.length > 0) {
				this.search_params.listing_attributes.map((item, index) => {
					if (item.attr_id == val.attr_id) {
						this.search_params.listing_attributes.splice(index, 1);
					}
				});
			}
		},
		getItemCondition(item) {
			this.conditionItem = item;
			this.listing_attributes.condition.pre_values_id = item.id;
			this.handleCheckListing(this.listing_attributes.condition);
			this.search_params.listing_attributes.push(
				this.listing_attributes.condition
			);
		},
		getItemSaleOrRent(item) {
			this.saleOrRentItem = item;
			this.listing_attributes.saleRent.pre_values_id = item.id;
			this.handleCheckListing(this.listing_attributes.saleRent);
			this.search_params.listing_attributes.push(
				this.listing_attributes.saleRent
			);
		},
		getItemGearType(item) {
			this.gearTypeItem = item;
			this.listing_attributes.gearType.pre_values_id = item.id;
			this.handleCheckListing(this.listing_attributes.gearType);
			this.search_params.listing_attributes.push(
				this.listing_attributes.gearType
			);
		},
		getItemJobType(item) {
			this.jobTypeItem = item;
			this.listing_attributes.jobType.pre_values_id = item.id;
			this.handleCheckListing(this.listing_attributes.jobType);
			this.search_params.listing_attributes.push(
				this.listing_attributes.jobType
			);
		},
		getItemOrderBy(name, item) {
			this.orderByItem.value = item;
			let prms = { ...this.search_params };

			prms.orderBy = name;

			this.search_params = prms;
		},
		findIndex(element) {
			const isNumber = item => item === element;

			let index = this.catagoryAttr.findIndex(isNumber);

			if (index != -1) {
				this.catagoryAttr.splice(index, 1);
			}
		},
		pushArrayLingtingAttr(element) {
			const isNumber = item => item === element;

			let index = this.catagoryAttr.findIndex(isNumber);

			if (index == -1) {
				this.catagoryAttr.push(element);
			}
		},
		handleCondition(array) {
			// this.listing_attributes.condition =  { "attr_id": 1,"pre_values_id": null,  "attr_type": "Select option"};
			if (array.length > 0) {
				array.map((item, key) => {
					if (item.id == 2) {
						this.condition.isCheck = false;
						this.condition.attr = item.listing_pre_values;
					}
				});
			}
		},
		handleSaleOrRent(array) {
			if (array.length > 0) {
				array.map((item, key) => {
					if (item.id == 1) {
						this.saleOrRent.isCheck = false;
						this.saleOrRent.attr = item.listing_pre_values;
					}
				});
			}
		},
		handleJobType(array) {
			if (array.length > 0) {
				array.map((item, key) => {
					if (item.id == 17) {
						this.jobType.isCheck = false;
						this.jobType.attr = item.listing_pre_values;
					}
				});
			}
		},
		handleGearType(array) {
			if (array.length > 0) {
				array.map((item, key) => {
					if (item.id == 12) {
						this.gearType.isCheck = false;
						this.gearType.attr = item.listing_pre_values;
					}
				});
			}
		},
		async showOrHideAttribute(filteredArray) {
			await this.hideAllAttributes(filteredArray);
			for (let attr of this.listingAttr) {
				switch (attr.id) {
					case 1:
						this.attributes.condition = true;
						this.attributes.price = true;
						this.attributes.area = true;
						break;
					case 2:
						this.attributes.saleRent = true;
						break;
					case 3:
						this.attributes.price = true;
						break;
					case 4:
						this.attributes.area = true;
						break;
					case 5:
						this.attributes.bedRoom = true;
						break;
					case 6:
						this.attributes.bathRoom = true;
						break;
					case 7:
						this.attributes.brand = true;
						break;
					case 8:
						this.attributes.model = true;
						break;
					case 9:
						this.attributes.year = true;
						break;
					case 10:
						this.attributes.price = true;
						break;
					case 11:
						this.attributes.Mileage = true;
						break;
					case 12:
						this.attributes.gearType = true;
						break;
					case 13:
						this.attributes.color = true;
						break;
					case 14:
						this.attributes.area = true;
						break;
					case 15:
						this.attributes.salary = true;
						break;
					case 17:
						this.attributes.jobType = true;
						break;
					default:
						break;
				}
			}
		},
		hideAllAttributes(filteredArray) {
			for (let attr of filteredArray) {
				switch (attr) {
					case 1:
						this.attributes.condition = false;
						this.conditionItem = null;

						this.attributes.price = false;
						this.search_params.minimum_price = null;
						this.search_params.maximum_price = null;

						this.attributes.area = false;
						this.provinceName = null;
						this.districtName = null;
						this.search_params.province_id = null;
						this.search_params.district_id = null;
						break;
					case 2:
						this.attributes.saleRent = false;
						this.saleOrRentItem = null;

						break;
					// case 3:
					// 	this.attributes.price = false;
					// 	this.search_params.minimum_price = null;
					// 	this.search_params.maximum_price = null;
					// 	break;
					case 4:
						this.attributes.area = false;
						this.provinceName = null;
						this.districtName = null;
						this.search_params.province_id = null;
						this.search_params.district_id = null;
						break;
					case 5:
						this.attributes.bedRoom = false;
						this.listing_attributes.bedroom.value = null;
						this.removeListingAttribute(5);
						break;
					case 6:
						this.attributes.bathRoom = false;
						this.listing_attributes.bathroom.value = null;
						this.removeListingAttribute(6);
						break;
					case 7:
						this.attributes.brand = false;
						this.listing_attributes.brand.value = null;
						this.removeListingAttribute(7);
						break;
					case 8:
						this.attributes.model = false;
						this.listing_attributes.model.value = null;
						this.removeListingAttribute(8);
						break;
					case 9:
						this.attributes.year = false;
						this.listing_attributes.year.value = null;
						this.removeListingAttribute(9);
						break;
					// case 10:
					// 	this.attributes.price = false;
					// 	this.search_params.minimum_price = null;
					// 	this.search_params.maximum_price = null;
					// 	break;
					case 11:
						this.attributes.Mileage = false;
						this.listing_attributes.mileage.value = null;
						this.removeListingAttribute(11);
						break;
					case 12:
						this.attributes.gearType = false;
						this.gearTypeItem = null;
						this.listing_attributes.mileage.pre_values_id = null;
						this.removeListingAttribute(12);
						break;
					case 13:
						this.attributes.color = false;
						this.listing_attributes.color.value = null;
						this.removeListingAttribute(13);
						break;
					case 14:
						this.attributes.area = false;
						this.provinceName = null;
						this.districtName = null;
						this.search_params.province_id = null;
						this.search_params.district_id = null;
						break;
					case 15:
						this.attributes.salary = false;
						this.search_params.minimum_salary = null;
						this.search_params.maximum_salary = null;
						break;
					case 17:
						this.attributes.jobType = false;
						this.jobTypeItem = null;
						this.listing_attributes.jobType.pre_values_id = null;
						this.removeListingAttribute(17);
						break;
					default:
						break;
				}
			}
		},
		removeListingAttribute(id) {
			// Search the index of the attribute
			const index = this.search_params.listing_attributes.findIndex(
				el => (el.id = id)
			);
			// remove it
			this.search_params.listing_attributes.splice(index, 1);
		},

		selectCatagory(val, id, index) {
			if (val) {
				this.catagoryCheck['catagory_' + id] = [];
				for (let data of this.categoriesOptions[index]
					.listing_category_children) {
					this.catagoryCheck['catagory_' + id].push(data.id);
				}
			} else {
				if (
					!val &&
					this.catagoryCheck['catagory_' + id].length ==
						this.categoriesOptions[index].listing_category_children.length
				) {
					this.catagoryCheck['catagory_' + id] = [];
				}
			}
			
		},
		saveCategory(data) {
			this.$store.commit('CategoryController/SET_CATEGORY', data);
		},
		saveListingAttr(data) {
			this.$store.commit('CategoryController/SET_CHECK_LISTING_ATTR', data);
		},

		handleEachCatagory(val, id, index) {
			if (
				val.length <
				this.categoriesOptions[index].listing_category_children.length
			) {
				this.allSelected['catagory_' + id] = false;
			}
			if (
				val.length ==
				this.categoriesOptions[index].listing_category_children.length
			) {
				this.allSelected['catagory_' + id] = true;
			}
		},
		searchSuggest(item) {
			this.isSuggest = false;
			this.valueBeforeSearch = item;

			this.search_params = {
				take: 14,
				page: 1,
				orderBy: '',
				listing_category_ids: null,
				search: item,
				province_id: null,
				district_id: null,
				minimum_price: null,
				maximum_price: null,
				minimum_salary: null,
				maximum_salary: null,
				user_id: null,
				listing_attributes: [],
				package_type: ''
			};

			this.catagoryCheck.catagory_1 = [];
			this.catagoryCheck.catagory_2 = [];
			this.catagoryCheck.catagory_3 = [];
			this.catagoryCheck.catagory_4 = [];
		},

		openThairathLogin() {
			this.$root.signIn('search');
		},
		setPageToOne() {
			if (this.$route.name === 'SearchGrid') {
				
				this.page = 1;
				this.search_params.page = 1;
				this.$router
					.push({ query: { ...this.$route.query, page: 1 } })
					.catch(() => {});
			}
		}
	},

	watch: {
		'catagoryCheck.catagory_1': function(val) {
			if (
				val.length < this.categoriesOptions[0].listing_category_children.length
			) {
				if (val.length == 0) {
					$('.checkbox_parent_01').removeClass('custom-lable-line');
				} else {
					$('.checkbox_parent_01').addClass('custom-lable-line');
				}
			} else {
				$('.checkbox_parent_01').removeClass('custom-lable-line');
			}
			this.handleSelected();
			this.setPageToOne();
			this.catagoryCheck.catagory_1 = val;

			this.handleEachCatagory(val, 1, 0);

			if (val.length > 0) {
				this.pushArrayLingtingAttr(this.categoriesOptions[0].id);
			} else {
				this.findIndex(this.categoriesOptions[0].id);
			}

			this.saveCategory(this.catagoryCheck);
		},
		'catagoryCheck.catagory_2': function(val) {
			if (
				val.length < this.categoriesOptions[1].listing_category_children.length
			) {
				if (val.length == 0) {
					$('.checkbox_parent_12').removeClass('custom-lable-line');
				} else {
					$('.checkbox_parent_12').addClass('custom-lable-line');
				}
			} else {
				$('.checkbox_parent_12').removeClass('custom-lable-line');
			}
			this.handleSelected();
			this.setPageToOne();
			this.catagoryCheck.catagory_2 = val;

			this.handleEachCatagory(val, 2, 1);

			if (val.length > 0) {
				this.pushArrayLingtingAttr(this.categoriesOptions[1].id);
			} else {
				this.findIndex(this.categoriesOptions[1].id);
			}

			this.saveCategory(this.catagoryCheck);
		},
		'catagoryCheck.catagory_3': function(val) {
			if (
				val.length < this.categoriesOptions[2].listing_category_children.length
			) {
				if (val.length == 0) {
					$('.checkbox_parent_23').removeClass('custom-lable-line');
				} else {
					$('.checkbox_parent_23').addClass('custom-lable-line');
				}
			} else {
				$('.checkbox_parent_23').removeClass('custom-lable-line');
			}
			this.handleSelected();
			this.setPageToOne();
			this.catagoryCheck.catagory_3 = val;

			this.handleEachCatagory(val, 3, 2);

			if (val.length > 0) {
				this.pushArrayLingtingAttr(this.categoriesOptions[2].id);
			} else {
				this.findIndex(this.categoriesOptions[2].id);
			}

			this.saveCategory(this.catagoryCheck);
		},
		'catagoryCheck.catagory_4': function(val) {
			if (
				val.length < this.categoriesOptions[3].listing_category_children.length
			) {
				if (val.length == 0) {
					$('.checkbox_parent_34').removeClass('custom-lable-line');
				} else {
					$('.checkbox_parent_34').addClass('custom-lable-line');
				}
			} else {
				$('.checkbox_parent_34').removeClass('custom-lable-line');
			}
			this.handleSelected();
			this.setPageToOne();
			this.catagoryCheck.catagory_4 = val;

			this.handleEachCatagory(val, 4, 3);

			if (val.length > 0) {
				this.pushArrayLingtingAttr(this.categoriesOptions[3].id);
			} else {
				this.findIndex(this.categoriesOptions[3].id);
			}

			this.saveCategory(this.catagoryCheck);
		},

		'allSelected.catagory_1': function(val) {
			if (
				val &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'marketPlace';
				this.searchTitle = this.$t('categories.market.market');
			} else if (
				!val &&
				this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'realEstate';
				this.searchTitle = this.$t('categories.realEstate.realEstate');
			} else if (
				!val &&
				!this.allSelected.catagory_2 &&
				this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'carsEngines';
				this.searchTitle = this.$t('categories.carsEngines.carsEngines');
			} else if (
				!val &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3 &&
				this.allSelected.catagory_4
			) {
				this.categorySelected = 'findAMotercycle';
				this.searchTitle = this.$t('categories.findAMotercycle.findAMotercycle');
			} else {
				this.categorySelected = 'features';
				this.searchTitle = this.$t('category');
			}

			this.selectCatagory(val, 1, 0);
			this.setPageToOne();
			if (val) {
				this.pushArrayLingtingAttr(this.categoriesOptions[0].id);
			} else {
				this.attributes.price = true;
				this.attributes.area = true;
				this.findIndex(this.categoriesOptions[0].id);
				this.listing_attributes.condition = {
					attr_id: 2,
					pre_values_id: null,
					value: null,
					attr_type: 'Number'
				};
				this.listing_attributes.saleRent = {
					attr_id: 1,
					pre_values_id: null,
					attr_type: 'Number'
				};
			}
		},
		'allSelected.catagory_2': function(val) {
			if (
				val &&
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'realEstate';
				this.searchTitle = this.$t('categories.realEstate.realEstate');
			} else if (
				!val &&
				this.allSelected.catagory_1 &&
				!this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'marketPlace';
				this.searchTitle = this.$t('categories.market.market');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				this.allSelected.catagory_3 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'carsEngines';
				this.searchTitle = this.$t('categories.carsEngines.carsEngines');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_3 &&
				this.allSelected.catagory_4
			) {
				this.categorySelected = 'findMotercycle';
				this.searchTitle = this.$t('categories.findMotercycle.findMotercycle');
			} else {
				this.categorySelected = 'features';
				this.searchTitle = this.$t('category');
			}

			this.selectCatagory(val, 2, 1);
			this.setPageToOne();
			if (val) {
				this.pushArrayLingtingAttr(this.categoriesOptions[1].id);
			} else {
				this.attributes.price = true;
				this.attributes.area = true;
				this.findIndex(this.categoriesOptions[1].id);
				this.listing_attributes.condition = {
					attr_id: 2,
					pre_values_id: null,
					attr_type: 'Number'
				};
				this.listing_attributes.saleRent = {
					attr_id: 1,
					pre_values_id: null,
					attr_type: 'Number'
				};
				this.listing_attributes.bedroom = {
					attr_id: 5,
					value: null,
					attr_type: 'Textbox'
				};
				this.listing_attributes.bathroom = {
					attr_id: 6,
					value: null,
					attr_type: 'Textbox'
				};
			}
		},
		'allSelected.catagory_3': function(val) {
			if (
				val && 
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'carsEngines';
				this.searchTitle = this.$t('categories.carsEngines.carsEngines');
			} else if (
				!val &&
				this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'marketPlace';
				this.searchTitle = this.$t('categories.market.market');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				this.allSelected.catagory_2 &&
				!this.allSelected.catagory_4
			) {
				this.categorySelected = 'realEstate';
				this.searchTitle = this.$t('categories.realEstate.realEstate');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				this.allSelected.catagory_4
			) {
				this.categorySelected = 'findMotercycle';
				this.searchTitle = this.$t('categories.findMotercycle.findMotercycle');
			} else {
				this.categorySelected = 'features';
				this.searchTitle = this.$t('category');
			}
			this.selectCatagory(val, 3, 2);
			this.setPageToOne();
			if (val) {
				this.pushArrayLingtingAttr(this.categoriesOptions[2].id);
			} else {
				this.attributes.price = true;
				this.attributes.area = true;
				this.findIndex(this.categoriesOptions[2].id);
				this.listing_attributes.brand = {
					attr_id: 7,
					value: null,
					attr_type: 'Textbox'
				};
				this.listing_attributes.model = {
					attr_id: 8,
					value: null,
					attr_type: 'Textbox'
				};
				this.listing_attributes.jobType = {
					attr_id: 17,
					pre_values_id: null,
					attr_type: 'Number'
				};
				this.listing_attributes.year = {
					attr_id: 9,
					value: null,
					attr_type: 'Textbox'
				};
				this.listing_attributes.mileage = {
					attr_id: 11,
					value: null,
					attr_type: 'Textbox'
				};
				this.listing_attributes.gearType = {
					attr_id: 12,
					pre_values_id: null,
					attr_type: 'Number'
				};
			}
		},
		'allSelected.catagory_4': function(val) {
			if (
				val &&
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3
			) {
				this.categorySelected = 'findMotercycle';
				this.searchTitle = this.$t('categories.findMotercycle.findMotercycle');
			} else if (
				!val &&
				this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3
			) {
				this.categorySelected = 'marketPlace';
				this.searchTitle = this.$t('categories.market.market');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				this.allSelected.catagory_2 &&
				!this.allSelected.catagory_3
			) {
				this.categorySelected = 'realEstate';
				this.searchTitle = this.$t('categories.realEstate.realEstate');
			} else if (
				!val &&
				!this.allSelected.catagory_1 &&
				!this.allSelected.catagory_2 &&
				this.allSelected.catagory_3
			) {
				this.categorySelected = 'carsEngines';
				this.searchTitle = this.$t('categories.carsEngines.carsEngines');
			} else {
				this.categorySelected = 'features';
				this.searchTitle = this.$t('category');
			}
			this.selectCatagory(val, 4, 3);
			this.setPageToOne();
			if (val) {
				this.pushArrayLingtingAttr(this.categoriesOptions[3].id);
			} else {
				this.attributes.price = true;
				this.attributes.area = true;
				this.findIndex(this.categoriesOptions[3].id);
				this.listing_attributes.gearType = {
					attr_id: 12,
					pre_values_id: null,
					attr_type: 'Number'
				};
			}
		},
		search_params: {
			deep: true,
			handler: _.debounce(function() {
				this.fetchDataSearch(this.search_params);
			}, 800)
		},
		provinceName: function(val) {
			this.district_parms.province_id = val.id;
			let prms = { ...this.district_parms };
			this.fetchDataDistricts(prms);
		},
		categoriesOptions: function(val) {
			this.manageCategoriesQuery();
			if (
				this.category &&
				this.category.catagory_1 &&
				this.category.catagory_2 &&
				this.category.catagory_3 &&
				this.category.catagory_4
			) {
				this.catagoryCheck = this.category;

				if (Object.keys(this.listing_attr).length) {
					this.listing_attributes = this.listing_attr;
				}
			} else if (
				this.$route.query.plan != 'mobile' &&
				!this.$route.query.categories
			) {
				switch (this.dataSearch.id) {
					case 1:
						this.allSelected.catagory_1 = true;
						break;
					case 2:
						this.allSelected.catagory_2 = true;
						break;
					case 3:
						this.allSelected.catagory_3 = true;
						break;
					case 32:
						this.allSelected.catagory_3 = true;
						this.catagoryCheck['catagory_3']=[32];
						break;
					case 4:
						this.allSelected.catagory_4 = true;
						break;
					default:
						this.allSelected.catagory_1 = true;
						this.saveCategory(this.catagoryCheck);
						break;
				}
			}
		},
		catagoryAttr: function(val) {
			if (val.length > 0) {
				this.list_attr_params.category_ids = val.toString();
				let prms = { ...this.list_attr_params };
				this.fetchDataListingAttr(prms);
			} else {
				this.hideAllAttributes(this.allAttr);
			}
		},
		listingAttr: async function(newVal) {
			const filteredArray = this.allAttr.filter(el => {
				return !newVal.some(val => {
					return el === val.id;
				});
			});

			await this.showOrHideAttribute(filteredArray);

			this.handleCondition(newVal);
			this.handleSaleOrRent(newVal);
			this.handleJobType(newVal);
			this.handleGearType(newVal);
		},

		'listing_attributes.bedroom.value': function(val) {
			this.handleCheckListing(this.listing_attributes.bedroom);
			this.search_params.listing_attributes.push(
				this.listing_attributes.bedroom
			);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_bedroom', val);
		},
		'listing_attributes.bathroom.value': function(val) {
			this.handleCheckListing(this.listing_attributes.bathroom);
			this.search_params.listing_attributes.push(
				this.listing_attributes.bathroom
			);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_bathroom', val);
		},
		'listing_attributes.year.value': function(val) {
			this.handleCheckListing(this.listing_attributes.year);
			this.search_params.listing_attributes.push(this.listing_attributes.year);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_year', val);
		},
		'listing_attributes.brand.value': function(val) {
			this.handleCheckListing(this.listing_attributes.brand);
			this.search_params.listing_attributes.push(this.listing_attributes.brand);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_brand', val);
		},
		'listing_attributes.model.value': function(val) {
			this.handleCheckListing(this.listing_attributes.model);
			this.search_params.listing_attributes.push(this.listing_attributes.model);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_model', val);
		},
		'listing_attributes.mileage.value': function(val) {
			this.handleCheckListing(this.listing_attributes.mileage);
			this.search_params.listing_attributes.push(
				this.listing_attributes.mileage
			);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_mileage', val);
		},
		'listing_attributes.color.value': function(val) {
			this.handleCheckListing(this.listing_attributes.color);
			this.search_params.listing_attributes.push(this.listing_attributes.color);
			this.saveListingAttr(this.listing_attributes);
			// this.manageQueries('atr_color', val);
		},
		page: function(val) {
			let prms = { ...this.search_params };
			prms.page = val;
			prms.listing_category_ids = this.catagoryAttr.toString();
			this.search_params = { ...prms };
		},
		'search_params.search': function(val) {
			this.GET_TEXT_SEARCH(val);

			if (val == '' || val == null) {
				this.isSuggest = false;
			} else {
				if (this.valueBeforeSearch != this.textSearch) {
					this.isSuggest = true;

					let prms = {
						take: 6,
						search: val
					};
					this.GET_LIST_SUGGEST(prms);
				}
			}
			this.manageQueries('search', val);
		},
		// watch queries for going back
		'$route.query.search'(val) {
			this.search_params.search = val;
		},
		'$route.query.categories'(val) {
			
			this.manageCategoriesQuery();
		},
		'$route.query.minimum_price'(val) {
			this.search_params.minimum_price = val;
		},
		'$route.query.maximum_price'(val) {
			this.search_params.maximum_price = val;
		},
		// Watch params to push queries
		'search_params.listing_category_ids'(val) {
			this.manageQueries('categories', val);
		},
		'search_params.minimum_price'(val) {
			this.manageQueries('minimum_price', val);
		},
		'search_params.maximum_price'(val) {
			this.manageQueries('maximum_price', val);
		},
		// 'search_params.minimum_salary'(val) {
		// this.manageQueries('minimum_salary', val);
		// },
		// 'search_params.maximum_salary'(val) {
		// this.manageQueries('maximum_salary', val);
		// },
		// 'search_params.province_id'(val) {
		// this.manageQueries('province_id', val);
		// },
		// 'search_params.district_id'(val) {
		// this.manageQueries('district_id', val);
		// },

		textSearch: function(val) {
			this.search_params.search = val;
		},
		isLogin: function(val) {
			if (val) {
				setTimeout(() => {
					this.userName = JSON.parse(
						localStorage.getItem('user_profile')
					).display_name;
				}, 500);
			}
		}
	}
};
</script>
<style lang="scss">
@import 'searchDesktop.scss';
</style>
